import React, { useContext } from 'react';
import './UnreadCount.module.scss';
import { SkillModalContext } from 'components/UI/SkillModal/SkillModal';

export default function UnreadCount({
  count,
  small,
}: {
  count: number;
  small?: boolean;
}) {
  const { inReflection } = useContext(SkillModalContext);
  return (
    <div
      styleName={`wrapper ${small ? 'small' : ''} ${
        inReflection ? '' : 'project'
      }`}
    >
      {count}
    </div>
  );
}
